import * as React from 'react';
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
import styled from 'styled-components';
import type { FieldFormProps } from '@helpcenter/field-types';
import { FieldSingleSelect } from '@helpcenter/form-select';
import * as grid from '@helpcenter/styles/src/grid';
import type { WrappedComponentProps } from 'react-intl-next';
import { FormattedMessage, injectIntl } from 'react-intl-next';
import type { OrganisationResponse } from 'rest/organisations';
import LockLockedIcon from '@atlaskit/icon/core/lock-locked';
import LockUnlockedIcon from '@atlaskit/icon/core/lock-unlocked';
import type { Option, ValueType } from '@atlaskit/select';
import { token } from '@atlaskit/tokens';
import i18n from './messages';

export interface Props extends Omit<FieldFormProps<string>, 'label'> {
    onSelectOrg: (org: ValueType<Option<string>>) => void;
    organisations: OrganisationResponse[];
    isLoading: boolean;
    isDisabled: boolean;
    selected: Option<string> | undefined;
}

const privateOption = () => (
    <>
        <IconWrap>
            <LockLockedIcon label="lock-icon" />
        </IconWrap>
        <FormattedMessage {...i18n.privateRequest} />
    </>
);

const organisationOption = (orgName: string) => (
    <>
        <IconWrap>
            <LockUnlockedIcon label="unlocked-icon" />
        </IconWrap>
        <FormattedMessage {...i18n.shareWith} values={{ orgName }} />
    </>
);

const renderOption = (option: { label: string; value: string }) => {
    if (!option.value) {
        return privateOption();
    }

    return organisationOption(option.label);
};

const createOption = (org: OrganisationResponse): Option<string> => ({ label: org.name, value: String(org.id) });

export const OrganisationPickerDumb: React.FunctionComponent<Props & WrappedComponentProps> = (props) => {
    const { organisations, description, selected, isLoading, isDisabled, onSelectOrg, id, intl } = props;

    const label = intl.formatMessage(i18n.shareWithLabel);
    const options = [...organisations.map(createOption), { label: intl.formatMessage(i18n.privateRequest), value: '' }];

    return (
        <OrganisationPicker
            id={id}
            required
            label={label}
            description={description}
            options={options}
            value={selected}
            formatOptionLabel={renderOption}
            onChange={onSelectOrg}
            isLoading={isLoading}
            isDisabled={isLoading || isDisabled}
            backspaceRemovesValue={false}
        />
    );
};

export default injectIntl(OrganisationPickerDumb);

// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const IconWrap = styled.span`
    margin-right: ${token('space.050', '4px')};
`;

// eslint-disable-next-line rulesdir/no-styled-export, @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
export const OrganisationPicker = styled(FieldSingleSelect)`
    display: inline-block;
    min-width: ${grid.multiple(30).px};
`;
